import axios from 'axios';

function Client() {
  var client = axios.create({
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
  client.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
  client.defaults.xsrfCookieName = 'csrftoken';
  return client;
}
export { Client };
export default Client;
